<article class="container section-outset-y">
  <header class="text-max-width-xs">
    <h2 class="h3">
      {{ block().title }}
    </h2>

    @if (block().intro) {
      <div
        class="markdown-content"
        fstrDynamicContent
        [innerHTML]="block().intro! | resizeHtmlImages | stripEmbed: cookiePreferences() | safe"
      ></div>
    }
  </header>

  <ul class="row gutter-y-4 gutter-lg-y-4">
    @for (card of cards(); track $index) {
      <li class="col-xsm-12 col-lg-8">
        <app-museum-collection-card
          [imageMode]="'crop'"
          [collection]="card.collection"
          [button]="card.button"
          [cookiePreferences]="cookiePreferences()"
          [intro]="card.intro"
        ></app-museum-collection-card>
      </li>
    }

    @if (block().button?.url || block().ctaTitle) {
      <li class="col-xsm-12 col-lg-8">
        <article class="card bg-primary-subtle h-100 p-4 pb-3 p-md-5 pb-md-4">
          @if (block().ctaTitle) {
            <h1 class="h5 fw-semi text-primary">{{ block().ctaTitle }}</h1>
          }
          @if (block().button?.url) {
            <fstr-link
              class="mt-auto"
              cssClasses="button button-link button--primary mt-5 mb-n2"
              [button]="block().button!"
              [showText]="false"
            >
              <span>{{ block().button?.text || 'Lees meer' }}</span>
              <fstr-icon anchor="line-icon-arrow-right"></fstr-icon>
            </fstr-link>
          }
        </article>
      </li>
    }
  </ul>
</article>
